import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { PaymentMode } from "../models";

@Injectable()
export class PaymentModeService {

    paymentModesUrl = environment.dns + 'api/payment-modes/';

    constructor(private http: HttpClient) { }

    getList(): Observable<PaymentMode[]> {
        return this.http.get<PaymentMode[]>(this.paymentModesUrl + 'list');
    }


}